import { Dayjs } from 'dayjs';
import { t } from 'i18next';

export const areaDropdown = [
    { value: '0', fullName: 'ALL'},
    { value: '1', fullName: 'Hong Kong Island' },
    { value: '2', fullName: 'New Territories' },
    { value: '3', fullName: 'Kowloon' },
];

export const districtDropdown = [
    { value: '0', fullName: 'ALL'},
    { value: '1', fullName: 'Lamma island' },
    { value: '2', fullName: 'Lantau Island' },
    { value: '3', fullName: 'Shek O' },
    { value: '4', fullName: 'Tai Po' },
    { value: '5', fullName: 'Tsuen Wan' },
    { value: '6', fullName: 'Tuen Mun' },
    { value: '7', fullName: 'Tung Lung Island' },
];


export function processFilter(filter: string)
{
    if(filter === 'ALL'){
        return null
    }
    return filter;
}

export function processDateFilter(filter: Dayjs)
{
    if(filter.toString() === 'Invalid Date'){
        return null
    }
    return filter.toISOString();
}

export const validateDates = (start: Dayjs  | null, end: Dayjs  | null , setError : any) => {
    if (start && end) {
        if (end.isBefore(start)) {
          setError(t('To Date cannot be earlier than From Date'));
        } else {
          setError(null);
        }
      } else {
        setError(null);
      }
};